<template>
  <v-container id="news-container" v-if="userById">
    <v-layout row wrap>
      <v-flex v-if="activeUser.id" md8 offset-md2 xs12 mb-2>
        <news-dialog :activeUser="activeUser"></news-dialog>
      </v-flex>
      <v-layout wrap justify-center>
        <v-flex xs11 md5 lg3-5 ma-1 v-for="item,i in sortedNews[activePage - 1]" :key="i" elevation-10 class="white">
          <v-card class="elevation-0" style="box-shadow: unset !important;">
            <v-layout row wrap>
              <v-flex xs12 v-if="userById[item.user_id]">
                <v-card-title class="indigo white--text ">
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex xs2 sm3 mb-3>
                        <img class="icon btn--round elevation-3 center-cropped-50 white "
                             :src="$helper.getLocation()+userById[item.user_id].img">
                      </v-flex>
                      <v-flex xs9>
                      <span
                        class="body-1"> {{userById[item.user_id].firstName}} {{userById[item.user_id].lastName}}:</span><br>
                        <span class="caption grey--text"> {{item.updated_at}}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 pl-5>
                    {{item.headline}}
                  </v-flex>
                </v-card-title>
              </v-flex>
              <v-flex xs12 grey lighten-2 class="text-xs-center">
                <img v-if="item.path !== '.'" class="responsive-img elevation-2 white"
                     :src="$helper.getLocation()+item.path" :alt="item.headline">
              </v-flex>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-dialog v-model="loginHintVis" width="400" light>
                    <v-card light>
                      <v-card-title class="indigo white--text ">Nicht Eingeloggt!</v-card-title>
                      <v-card-text>Bitte klicke oben rechts auf den Login-Button, um News zu liken und zu kommentieren.</v-card-text>
                      <v-card-actions><v-spacer></v-spacer>
                        <v-btn color="indigo darken-1"  flat @click.native="toggleLoginHint()">OK</v-btn></v-card-actions></v-card></v-dialog>

                  <v-badge bottom :overlap="true"
                           :title="activeUser.id ? 'Like' : 'Please login on the top right to like this item.'"
                           class="ml-4 small-badge" :class="activeUser.id ? 'cursor-pointer highlight' : ''"
                           @click.native="activeUser.id ? like({item,val:'like', user_id: activeUser.id}) : toggleLoginHint('like')">
                    <span slot="badge" class="small">{{item.likes.split(',').length - 1}}</span>
                    <v-icon class="text-elevation-5" medium
                            :color="item.likes.indexOf(activeUser.id)>-1 ? 'blue darken-3' : 'blue lighten-3'">thumb_up
                    </v-icon>
                  </v-badge>
                  <v-badge bottom :overlap="true"
                           :title="activeUser.id ? 'Mark as favorite' : 'Please login on the top right to like this item.'"
                           class="small-badge" :class="activeUser.id ? 'cursor-pointer highlight' : ''"
                           @click.native="activeUser.id ? like({item,val:'favorite', user_id: activeUser.id}) : toggleLoginHint('favorite')">
                    <span slot="badge">{{item.likes_favorite.split(',').length - 1}}</span>
                    <v-icon class="text-elevation-5" medium
                            :color="item.likes_favorite.indexOf(activeUser.id)>-1 ? 'red darken-3' : 'red lighten-3'">
                      favorite
                    </v-icon>
                  </v-badge>
                  <v-badge bottom :overlap="true" title="Comments"
                           class="cursor-pointer small-badge2 ml-5"
                           @click.native="activate(item)"
                           color="grey">
                    <span slot="badge">{{item.comments}}</span>
                    <v-icon class="" medium>comment</v-icon>
                  </v-badge>
                </v-layout>
              </v-flex>
              <v-flex xs12 class="mb-5">
                <v-card-text class="word-break">{{item.short_text}}</v-card-text>
              </v-flex>
            </v-layout>
            <span class="artikel" @click="activate(item)">→ Zum Artikel</span>
          </v-card>
        </v-flex>
      </v-layout>
    </v-layout>
    <full-article :dialog="dialog" @update:dialog="val => dialog = val"></full-article>
    <div class="text-xs-center">
      <v-pagination :length="sortedNews.length" v-model="activePage" circle @input="info()"></v-pagination>
    </div>
  </v-container>
</template>
<script>

  import {mapGetters, mapActions} from 'vuex';
  import CommentsPage from './news/comments';
  import FullArticle from './news/FullArticle';
  import NewsDialog from './news/NewsDialog';

  export default {
    components: {
      NewsDialog,
      FullArticle,
      CommentsPage,
    },
    name: 'news',
    computed: {
      ...mapGetters(['allNews', 'userById', 'activeUser', 'commentsById']),
      sortedNews() {
        let news = this.allNews;
        let localNews = [];
        let i = news.length - 1;
        while (i >= 0) {
          let j = 0;
          let innerArr = [];
          for (j; j < 8; j += 1) {
            if (news[i])
              innerArr.push(news[i]);
            i -= 1;
          }
          localNews.push(innerArr);
        }
        return localNews;
      },
    },
    data() {
      return {
        msg: 'Welcome to Your Vue.js App',
        activeArr: [false, false, false, false],
        active: 0,
        toggleLike: false,
        rowsMultiline: 1,
        dialog: false,
        myHTML: '',
        activePage: 1,
          loginHintVis: false,
        news: {
          user_id: '',
          short_text: '',
          long_text: '',
          imgFile: '',
          fileName: '',
          media_type: 'img',
          headline: 'Headline',
          text: '',
          type: 'news',
          id: '',
          comments: '',
          likes: '',
          likes_favorite: '',
        },
      };
    },
    methods: {
      ...mapActions(['likeNews', 'updatePoints', 'setActiveComment', 'setActiveArticle']),
      like({item, val, user_id}) {
        this.toggleLike = true;
        this.likeNews({item, val, user_id, cb: this.updatePoints});
          ga('send', {
              hitType: 'event',
              eventCategory: val === 'favorite' ? 'favoriteBtn' : 'likeBtn',
              eventAction: 'like',
              eventLabel: 'like',
              eventValue: 200
          });
      },
        toggleLoginHint(val){
          this.loginHintVis = !this.loginHintVis
            ga('send', {
                hitType: 'event',
                eventCategory: val === 'favorite' ? 'favoriteBtn' : 'likeBtn',
                eventAction: 'like',
                eventLabel: 'like_attempt',
                eventValue: 50
            });
        },
      activate(item) {
          ga('send', {
              hitType: 'event',
              eventCategory: 'news_more_info_page',
              eventAction: 'navigate',
              eventLabel: 'news_interaction',
              eventValue: 1
          });
        this.setActiveComment(item.id);
        this.setActiveArticle(item);
        this.$router.push({path: 'article/' + item.id});
        this.dialog = true;
      },
      info(){
        // console.log('info')
        setTimeout(()=> {   this.$vuetify.goTo('#news-container', {offset: -100, duration: 300, easing: 'easeOutCubic'})},100)

      }

    },
    mounted() {
      setTimeout(() => {
        if (this.$route.params.id) {
          if (location.href.split('/')[location.href.split('/').length - 2] === 'article') {
            const item = this.$helper.getObjectsByKey('id', parseInt(this.$route.params.id, 10), this.allNews);
            this.setActiveComment(item[0].id);
            this.setActiveArticle(item[0]);
            this.dialog = true;
          }
        }
      }, 100);
      // console.log('mounted news');
      // console.log(this.activeUser);
    },
    created() {
      // console.log('created news');
      // console.log(this.activeUser);
    },
  };
</script>
<style>

  @media (min-width: 1264px) {
    #app .flex.lg3-5 {
      -ms-flex-preferred-size: 25%;
      flex-basis: 24.5%;
      max-width: 24.5%;
    }
  }

</style>
